import React from "react";
import { Card, Space, Button, Typography, theme } from "antd";
import { ClockCircleOutlined, SendOutlined } from "@ant-design/icons";

const { Text } = Typography;

interface Props {
  resendingInvite: boolean;
  onResendInvite: () => void;
}

const EmployeeInvitationNotice: React.FC<Props> = ({
  resendingInvite,
  onResendInvite,
}) => {
  const { token } = theme.useToken();
  return (
    <Card
      size="small"
      style={{
        marginBottom: 24,
        backgroundColor: token.colorWarningBg,
        borderColor: token.colorWarningBorder,
      }}
    >
      <Space align="start" style={{ width: "100%" }}>
        <ClockCircleOutlined
          style={{ fontSize: 16, marginTop: 4, color: token.colorWarning }}
        />
        <div style={{ flex: 1 }}>
          <Text strong style={{ display: "block" }}>
            Invitation Pending
          </Text>
          <Text
            type="secondary"
            style={{
              display: "block",
              marginBottom: 8,
              color: token.colorTextSecondary,
            }}
          >
            This employee hasn't accepted their invitation yet. You can resend
            the invitation email.
          </Text>
          <Button
            icon={<SendOutlined />}
            size="small"
            onClick={onResendInvite}
            loading={resendingInvite}
            style={{
              backgroundColor: token.colorWarning,
              borderColor: token.colorWarning,
              borderRadius: 6,
            }}
          >
            Resend Invitation
          </Button>
        </div>
      </Space>
    </Card>
  );
};

export default EmployeeInvitationNotice;
